import { render } from "./watch_detail.vue?vue&type=template&id=92ea430a"
import script from "./watch_detail.vue?vue&type=script&lang=js"
export * from "./watch_detail.vue?vue&type=script&lang=js"

import "./watch_detail.vue?vue&type=style&index=0&id=92ea430a&lang=css"

import exportComponent from "/Users/wanfeng/code/userBehavior-course/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__